import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Icon from '../../../../../atoms/Icon'
import Markup from '../../../../../atoms/Markup'
import { ICON_NAMES } from '../../../../../../constants'
import { detectMarkupType } from '../helpers'

const useStyles = makeStyles((theme) => ({
  popper: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: 'var(--theme-color-surface-d0)',
      color: 'var(--text-color-main)',
      border: 'var(--border-neutral-emphasis)',
      boxShadow: theme.layout.shadow.deep,
      lineHeight: '18px',
      padding: '6px 12px',
      maxWidth: '400px',
      fontSize: 'var(--font-size-sm)'
    }
  }
}))

function DescriptionTooltip ({ description }) {
  const classes = useStyles()
  if (!description) return null
  return (
    <Tooltip
      classes={{ popper: classes.popper }}
      placement='top'
      title={<Markup value={description} type={detectMarkupType(description)} style={{ fontSize: 'inherit' }} />}
    >
      <span style={{ display: 'inline-flex' }}>
        <Icon name={ICON_NAMES.info} customSize={16} />
      </span>
    </Tooltip>
  )
}

DescriptionTooltip.propTypes = {
  description: PropTypes.string
}

export default DescriptionTooltip
